import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { ControlLabel, FormGroup } from 'react-bootstrap';

import { getOutlets } from '../../../actions/outlet';
import OutletSubmissions from './outlet-submissions';

class SubmissionsDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOutlet: null,
      selectedOutletId: null,
      shouldDisplayTable: false
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getOutlets(false));
  }

  handleOnChange = (option) => {
    this.setState({
      selectedOutletId: option.value,
      selectedOutlet: this.props.outlets.find(outlet => outlet.id === option.value),
      shouldDisplayTable: true,
    });
  }

  render() {
    const { outlets, handleTabSelect } = this.props;
    const { selectedOutlet, selectedOutletId, shouldDisplayTable } = this.state;

    const outletsData = outlets.map(outlet => (
      {
        value: outlet.id,
        label: outlet.attributes.name
      }
    ));

    return (
      <div>
        <FormGroup
          className="select-formgroup form-group dashboard-select"
        >
          <ControlLabel>Outlet</ControlLabel>
          <Select
            className='form-control'
            cache={false}
            isClearable
            searchable
            closeOnSelect
            onChange={option => this.handleOnChange(option)}
            options={outletsData}
            placeholder={'Choose an Outlet'}
            value={selectedOutletId}
          />
        </FormGroup>
        {shouldDisplayTable && (
          <h4>{selectedOutlet.attributes.name}</h4>
        )}
        <div>
          {shouldDisplayTable && (
            <div>
              <OutletSubmissions
                key={selectedOutlet.id}
                outlet={selectedOutlet}
                handleTabSelect={handleTabSelect}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  outlets: state.stores.stores || []
});

export default connect(mapStateToProps)(SubmissionsDashboard);



// WEBPACK FOOTER //
// ./src/components/submissions/dashboard/submissions-dashboard.jsx